import { createContext } from "react";
export const NodeViewContext = /*#__PURE__*/ createContext(null);
